import { ConstantsData } from "./constants";

export const sampleEmailData = {
    "structures": [
        {
            "id": 1700116047615,
            "type": "2",
            "blocks": [
                [
                    {
                        "src": "https://sendwithses-033267325636-1669966595547545450-us-east-1.s3.amazonaws.com/1700758278545313230.jpg",
                        "type": "Image",

                        "link": "",
                        "align": "center",
                        "title": "",
                    },
                    {
                        "type": "Text",
                        "color": "#000000",
                        "content": "<h3>H3 Text Header</h3>"
                    },
                    {
                        "type": "Body",
                        "color": "#000000",
                        "content": '<p>The future of <strong>football</strong> in India depends on how many <u>kids</u> under 10 start <span style="color: rgb(255, 228, 0)">taking</span> an <span style="font-size: 22px">interest</span> in the <span style="font-family: Courier New">game</span>.<br></p>'
                    }
                ],
                [
                    {
                        "src": "https://sendwithses-033267325636-1669966595547545450-us-east-1.s3.amazonaws.com/1700758278545313230.jpg",
                        "type": "Image",
                    },
                    {
                        "type": "Button",
                        "color": "#333333",
                        "content": "Sample Button",
                        "backgroundColor": "#c54949",
                        "font": 'Verdana',
                        "fontSize": '16px',
                        "align": 'center',
                        "link": 'cv.me'
                    }
                ]
            ],
        },
        {
            "id": 1700116047611,
            "type": "1",
            "blocks": [
                [
                    {
                        "src": "https://sendwithses-033267325636-1669966595547545450-us-east-1.s3.amazonaws.com/1702473941486404369.jpg",
                        "type": "Image",
                        "link": "",
                        "align": "center",
                        "title": "",
                        "width": "1024"
                    },
                    {
                        "src": "https://sendwithses-033267325636-1669966595547545450-us-east-1.s3.amazonaws.com/1698836249288331996.jpg",
                        "type": "Video",
                        "link": "https://www.youtube.com/watch?v=-ObdvMkCKws",
                        "align": "center",
                        "title": "",
                    },
                    {
                        "type": "Text",
                        "color": "#000000",
                        "content": "<h2><span class=\"ql-size-small\">asdasdas </span><strong class=\"ql-size-huge\">asda</strong><span class=\"ql-size-small\"> sd</span></h2>"
                    }
                ],
            ],
        }
    ],
    "general": {
        "name": "",
        "previewText": "",
        "width": "600px",
        "color": "#000000",
        "background": "#EEEEEE",
        "contentBackground": "#FFFFFF",
        footer: {
            content: 'Click here to add footer text.',
            unsubscribe: true,
            brands: [
            ]
        },
        logo: {
            src: 'https://sendwithses-033267325636-1669966595547545450-us-east-1.s3.amazonaws.com/1701352769686931378.jpg',
            link: '',
            align: 'center'
        }
    }
}